import React, { useState } from "react";
import "../../css/index.css";
import Button from "./Components/Button";
import Select from "react-select";
import { Checkbox } from "@mui/material";
import { useTranslation } from 'react-i18next';

const PdfParserPagina = () => {
    const [file, setFile] = useState(null);
    const [pdfText, setPdfText] = useState("");
    const [pdfParsingMethod, setPdfParsingMethod] = useState("Paragraphs");
    const [toJson, setToJson] = useState(false);
    const { t } = useTranslation();

    const pdfParsingMethods = ["Paragraphs", "Spaces"].map((value) => ({
        label: value,
        value: value,
    }));

    const handlePdfToText = async () => {
        if (!file) {
            alert("no file selected");
            return;
        }

        const url =
            process.env.REACT_APP_PDF_PARSER_URL +
            "/parse" +
            (toJson ? "/toJson" : "") +
            "?textExtractionMode=" +
            pdfParsingMethod;

        const response = await fetch(url, {
            method: "POST",
            body: await file.arrayBuffer(),
        });

        const text = await response.text();
        setPdfText(text);
    };

    const ContentBoxHeader = () => (
        <div className="bg-[#00aaad] dark:bg-[#008b8e] relative shrink-0 w-full">
            <div className="absolute border border-gray-400 inset-0 pointer-events-none" />
            <div className="flex flex-col items-center justify-center size-full">
                <div className="flex flex-col items-center justify-center px-[530px] py-[10px] w-full">
                    <div className="capitalize font-bold text-[20px] text-center w-[200px]">
                        <p className="leading-[1.45]">{t("pdfParser.header")}</p>
                    </div>
                </div>
            </div>
        </div>
    );

    const PdfTextBox = () => (
        <div className="bg-white dark:bg-gray-700 h-[90%] w-[90%] relative">
            <div className="overflow-clip rounded-[inherit] size-full">
                <textarea
                    id="outputTextBox"
                    className="h-[1000px] w-full p-[5px] bg-transparent text-black dark:text-white resize-none"
                    placeholder={t("pdfParser.outputPlaceholder")}
                    value={pdfText}
                    readOnly
                />
            </div>
            <div className="absolute border border-black inset-0 pointer-events-none" />
        </div>
    );

    const MainContentFrame = () => (
        <div className="bg-[rgba(243,244,246,0.75)] dark:bg-[rgba(55,65,81,0.75)] w-full relative">
            <div className="absolute border border-gray-400 inset-0 pointer-events-none" />
            <div className="flex flex-col items-center size-full">
                <div className="flex flex-row gap-[5%] items-center px-[5%] py-[10px] w-full">
                    <Button text={t("pdfParser.parseBtn")} width="7%" onClick={handlePdfToText} />

                    <div className="flex flex-row items-center gap-[5px]">
                        <label>{t("pdfParser.jsonCheckboxLabel")}</label>
                        <Checkbox
                            checked={toJson}
                            onChange={() => setToJson((prev) => !prev)}
                        />
                    </div>

                    <div className="flex flex-row items-center gap-[5px]">
                        <label>{t("pdfParser.parseMethodLabel")}</label>
                        <Select
                            options={pdfParsingMethods}
                            value={pdfParsingMethods.find(
                                (opt) => opt.value === pdfParsingMethod
                            )}
                            onChange={(option) =>
                                setPdfParsingMethod(option.value)
                            }
                        />
                    </div>

                    <input
                        type="file"
                        accept=".pdf"
                        onChange={(e) => setFile(e.target.files[0])}
                    />
                </div>

                <PdfTextBox />
            </div>
        </div>
    );

    return (
        <div className="relative size-full">
            <div className="flex flex-row items-start size-full gap-5">
                <div className="flex flex-col px-0 py-2 size-full">
                    <ContentBoxHeader />
                    <MainContentFrame />
                </div>
            </div>
        </div>
    );
};

export default PdfParserPagina;